var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('kt-icon',{staticClass:"kt-nav__link-icon",attrs:{"type":_vm.type,"name":_vm.name}})}
var staticRenderFns = []

export { render, staticRenderFns }